import { render, staticRenderFns } from "./YqList.vue?vue&type=template&id=94e2daae&scoped=true"
import script from "./YqList.vue?vue&type=script&lang=js"
export * from "./YqList.vue?vue&type=script&lang=js"
import style0 from "./YqList.vue?vue&type=style&index=0&id=94e2daae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e2daae",
  null
  
)

export default component.exports